import { cn } from './cn'

/**
 * REDESIGN section 9: cta = gold (#F7CF6A, hover #F2C04B) with #1F1F1F text and an UPPERCASE 600 label (VIEW,
 * JOIN COMMUNITY, JOIN $29/month, UPGRADE, LOG IN on forms); outline = white with a strong line and an
 * UPPERCASE label (LOG IN in the top bar, INVITE PEOPLE, SETTINGS, CHAT); primary = dark fill, sentence case
 * (form saves, dialogs). brand is an alias of cta.
 */
export type ButtonVariant = 'primary' | 'cta' | 'brand' | 'outline' | 'secondary' | 'ghost' | 'danger' | 'link'
export type ButtonSize = 'sm' | 'md' | 'lg'

const base =
  'relative inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-control font-semibold ' +
  'select-none transition-[color,background-color,border-color,box-shadow,opacity] duration-150 ease-out ' +
  'focus-ring disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 ' +
  '[&_svg]:shrink-0'

const cta = 'bg-cta text-on-cta uppercase tracking-[0.02em] hover:bg-cta-hover'

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-primary text-on-primary hover:bg-primary-hover',
  cta,
  brand: cta,
  outline: 'border border-line-strong bg-surface text-outline-text uppercase tracking-[0.02em] hover:bg-surface-2 hover:text-text',
  secondary: 'border border-line-strong bg-surface text-text hover:bg-surface-2',
  ghost: 'bg-transparent text-text hover:bg-surface-2',
  danger: 'bg-danger text-white hover:bg-danger-hover',
  link: 'h-auto rounded-sm bg-transparent px-0 text-link underline-offset-2 hover:underline',
}

const sizes: Record<ButtonSize, string> = {
  sm: 'h-8 max-sm:h-10 px-3 text-btn-sm [&_svg]:size-4',
  md: 'h-10 px-4 text-btn [&_svg]:size-[18px]',
  lg: 'h-12 px-5 text-btn-lg [&_svg]:size-5',
}

const linkSizes: Record<ButtonSize, string> = {
  sm: 'text-btn-sm [&_svg]:size-4',
  md: 'text-btn [&_svg]:size-4',
  lg: 'text-btn-lg [&_svg]:size-5',
}

export function buttonClasses({
  variant = 'primary',
  size = 'md',
  fullWidth,
  className,
}: { variant?: ButtonVariant; size?: ButtonSize; fullWidth?: boolean; className?: string } = {}) {
  return cn(
    base,
    variant === 'link' ? linkSizes[size] : sizes[size],
    variants[variant],
    fullWidth && 'w-full shrink',
    className,
  )
}
